import React from "react";
import "./LegalPage.css";

function TermsOfServicePage() {
  return (
    <div className="legal-page">
      <section className="legal-page-hero">
        <span className="legal-page-kicker">JOBFIND24</span>
        <h1>Terms of Service</h1>
        <p className="legal-page-intro">
          These Terms of Service govern the use of the JOBFIND24 website, including access to job alerts, exam updates, admit cards, results, answer keys, syllabus content, admissions information, and contact features.
        </p>
        <p className="legal-page-updated">Last updated: March 9, 2026</p>
      </section>

      <div className="legal-page-grid">
        <section className="legal-page-card">
          <h2>1. Use of the Website</h2>
          <p>
            JOBFIND24 is intended to provide informational content related to recruitment, examinations, educational notices, and similar updates. By using this website, you agree to use it only for lawful and responsible purposes.
          </p>
        </section>

        <section className="legal-page-card">
          <h2>2. Accuracy of Information</h2>
          <p>
            We make reasonable efforts to publish timely and useful updates, but we do not guarantee that every job post, result, admit card, answer key, syllabus entry, or admission notice will always be complete, current, or error-free. Users should verify important details from official sources before acting on any information.
          </p>
        </section>

        <section className="legal-page-card">
          <h2>3. External Websites and Official Sources</h2>
          <p>
            Some links on JOBFIND24 may direct users to official portals or third-party websites. We are not responsible for the availability, policies, accuracy, or content of those external destinations.
          </p>
        </section>

        <section className="legal-page-card">
          <h2>4. User Conduct</h2>
          <ul>
            <li>Do not misuse the contact form, search tools, or any interactive feature.</li>
            <li>Do not attempt unauthorized access to admin areas, APIs, or stored data.</li>
            <li>Do not submit harmful, misleading, abusive, or unlawful content.</li>
            <li>Do not interfere with the normal operation or security of the website.</li>
          </ul>
        </section>

        <section className="legal-page-card">
          <h2>5. Intellectual Property and Website Content</h2>
          <p>
            The website design, branding, compiled listings, and original content prepared for JOBFIND24 remain the property of the website owner unless otherwise stated. Official job notices, public exam information, and linked source material remain subject to their respective owners or authorities.
          </p>
        </section>

        <section className="legal-page-card">
          <h2>6. Service Availability</h2>
          <p>
            We may update, suspend, restrict, or remove any feature, route, page, or content section without prior notice when required for maintenance, corrections, moderation, or operational changes.
          </p>
        </section>

        <section className="legal-page-card">
          <h2>7. Limitation of Liability</h2>
          <p>
            JOBFIND24 is provided on an as-available basis. We are not liable for losses, missed deadlines, or decisions made solely on the basis of information published here. Users remain responsible for independently verifying deadlines, eligibility, application steps, and official announcements.
          </p>
        </section>

        <section className="legal-page-card">
          <h2>8. Changes to These Terms</h2>
          <p>
            These Terms of Service may be revised from time to time. Continued use of the website after updates means you accept the latest version published on this page.
          </p>
        </section>
      </div>
    </div>
  );
}

export default TermsOfServicePage;